import React, { useEffect, useState } from 'react';
import { LoginState } from '../../types/LoginState';
import { useClubContext } from '../../hooks/ClubContext';
import { ClubLink } from '../../types/clubLinksTypes';
import WWEvents from '../../WWEvents';
import AccountFlyout from './AccountFlyout';
import AccountIcon from './AccountIcon';
import { useHeaderContext } from 'Components/HeaderContext';

const Account = ({ isLoggedIn, isPartiallyLoggedIn }: LoginState): JSX.Element => {
    const { t } = useHeaderContext();
    const { links } = useClubContext();
    const [showFlyout, setShowFlyout] = useState(false);

    const handleClick = (evt: React.MouseEvent) => {
        if (!isLoggedIn && isPartiallyLoggedIn) {
            evt.preventDefault();
            WWEvents.fire('SIGNUP_OVERLAY_OPEN', {
                isClosable: true,
            });
        }
    };

    useEffect(() => {
        if (isLoggedIn === true || isPartiallyLoggedIn === true) {
            setShowFlyout(true);
        }
    }, [isLoggedIn, isPartiallyLoggedIn]);
    return showFlyout ? (
        <AccountFlyout onClickWhenLoginRequired={handleClick} />
    ) : (
        <AccountIcon
            data-testid="oww-header-account-icon"
            onClick={handleClick}
            href={links[ClubLink.CUSTOMER_ACCOUNT].path}
            ariaLabel={t('OwwHeader_My account')}
        />
    );
};

export default Account;
